/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import Script from 'next/script'
import PropTypes from 'prop-types'

import API from 'api'
import globalRequest from 'common/utils/globalRequest'
import QuoteList from 'components/quote/quoteList'
import QuoteLayout from 'layouts/QuoteLayout'


export async function getServerSideProps({ locale, query }) {
  const [ quoteData, utmData ] = await Promise.all([
    API.get(`api/v2/public/quotes/${query.id}`, { headers: { 'Accept-Language': locale } }).catch(() => null),
    API.get('api/v1/info', { headers: { 'Accept-Language': locale } }).catch(() => ({ quote_utm_tags: {} })),
  ])
  if(!quoteData) {
    return { notFound: true }
  }
  const defaultValues = await globalRequest(locale)
  const initialReduxStore = {
    ...defaultValues,
    quoteList: {
      data: quoteData,
    },
    utmData: {
      data: utmData,
    },
  }
  return { props: { initialReduxStore, locale, withCover: true } }
}

QuoteListPage.propTypes = {
  locale: PropTypes.string.isRequired,
}

export default function QuoteListPage({ locale }) {
  return (
    <QuoteLayout>
      <Script strategy="beforeInteractive" src="/scripts/initMap.js" />
      <Script src={`https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAP_KEY}&libraries=places&libraries=marker&language=${locale}&loading=async&callback=initMap`} />
      <QuoteList />
    </QuoteLayout>
  )
}
